import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getPendingBroadcastMessages,
  actionBroadcastMessage,
} from "@/services";
import BroadcastModal from "./BroadcastModal";

const BroadcastMessageWrapper = () => {
  const dispatch = useDispatch();
  const { messages, currentIndex, isOpen, submitting, hasFetched } =
    useSelector((state) => state.broadcast);
  const current = messages[currentIndex];

  useEffect(() => {
    if (!hasFetched) {
      dispatch(getPendingBroadcastMessages());
    }
  }, [dispatch, hasFetched]);

  if (!isOpen || !current) {
    return null;
  }

  const handleDismiss = ({ id }) => {
    dispatch(actionBroadcastMessage({ id, action: "dismiss" }));
  };

  const handleAcknowledge = ({ id }) => {
    dispatch(actionBroadcastMessage({ id, action: "acknowledge" }));
  };

  return (
    <BroadcastModal
      message={current}
      submitting={submitting}
      onDismiss={handleDismiss}
      onAcknowledge={handleAcknowledge}
    />
  );
};

export default BroadcastMessageWrapper;
